import React from "react";

export default function DonutSummary({
  value = 0,
  total = 0,
  title = "ONLINE",
  perc = 0,
  subtitle = "Ultimas 24 hrs",
  size = 160,           // tamaño total del SVG (px)
  strokeWidth = 18,     // grosor de la dona
  color = "#8ad24f",    // verde
  track = "#d9d9d9",    // gris claro del track
  bg = "#242424",       // fondo del panel
  textColor = "#999999" // color de textos
}) {
  const safeTotal = Math.max(0, Number(total) || 0);
  const safeValue = Math.max(0, Math.min(Number(value) || 0, safeTotal));
  const progress = safeTotal > 0 ? safeValue / safeTotal : 0;

  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const dashOffset = circumference * (1 - progress);

  // Si está al 100%, evitamos “bolitas” en unión usando 'butt'
  const linecap = progress >= 0.999 ? "butt" : "round";

  const containerStyle = {
    width: size,
    height: size,
    background: bg,
    borderRadius: 12,
    display: "grid",
    placeItems: "center",
    padding: 12,
  };

  const wrapStyle = {
    position: "relative",
    width: size,
    height: size,
    display: "grid",
    placeItems: "center",
  };

  const centerStyle = {
    position: "absolute",
    inset: 0,
    display: "grid",
    gridTemplateRows: "auto 1fr auto",
    alignItems: "center",
    justifyItems: "center",
    pointerEvents: "none",
    color: textColor,
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
    textAlign: "center",
  };

  const titleStyle = { fontSize: 14, opacity: 0.9, marginTop: -20, letterSpacing: 1, textTransform: "uppercase",color:'#abfdae' };
  const numberStyle = { fontSize: 36, fontWeight: 700,marginTop: 20,  color: color, lineHeight: 1 };
  const percStyle = { fontSize: 10,  marginTop: 0,};
  const subtitleStyle = { fontSize: 14, marginTop: 20,};
   

  return (
    <div style={containerStyle}>
      <div style={wrapStyle}>
        {/* Capa de textos */}
        <div style={centerStyle}>
          <div style={titleStyle}>{title}</div>
          <div style={numberStyle}>{safeValue}</div>
          <div style={percStyle}>{perc} %</div>
          <div style={percStyle}>de {total}</div>
          <div style={subtitleStyle}>{subtitle}</div>
        </div>

        {/* Donut */}
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
          <g transform={`rotate(-90 ${size / 2} ${size / 2})`}>
            {/* Track */}
            <circle
              cx={size / 2}
              cy={size / 2}
              r={radius}
              fill="none"
              stroke={track}
              strokeWidth={strokeWidth}
            />
            {/* Progreso */}
            <circle
              cx={size / 2}
              cy={size / 2}
              r={radius}
              fill="none"
              stroke={color}
              strokeWidth={strokeWidth}
              strokeDasharray={circumference}
              strokeDashoffset={dashOffset}
              strokeLinecap={linecap}
              style={{ transition: "stroke-dashoffset 0.6s ease" }}
            />
          </g>
        </svg>
      </div>
    </div>
  );
}
